<template>
  <div>
    <v-dialog v-if="dialog" v-model="dialog" :width="getWidth" persistent scrollable @keyup.esc="closeDialog">
      <v-card class="py-0">
        <v-card-text class="pa-5">
          <component :is="section.component" ref="SECTION_DIALOG" v-bind="currentProperties" v-on="events"></component>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
  import Section from '@/framework/base/classes/Section';
  import Route from '@/generated/classes/Route';
  import { FieldStatus } from '@/framework/base/components/FieldInfo';
  import { MapRessource } from '@/framework/base/helpers/Ressources';
  import { type PropType, defineComponent } from 'vue';

  export default defineComponent({
    name: 'SectionContainer',
    components: {},
    props: {
      section: {
        type: Section,
        required: true,
      },
      dialogOpen: {
        type: Boolean,
        required: false,
      },
      sectionSave: {
        type: Boolean,
        required: false,
      },
      helper: {
        type: Boolean,
        required: false,
      },
      moduleId: {
        type: Number,
        required: false,
      },
      fullscreen: {
        type: Boolean,
        required: false,
      },
      midSize: {
        type: Boolean,
        required: false,
      },
      dialogWidth: {
        type: [Number, String],
        required: false,
      },
      hideHeader: {
        type: Boolean,
        required: false,
      },
      isSalarie: {
        type: Boolean,
        required: false,
      },
      readOnly: {
        type: Boolean,
        required: false,
      },
      showMissing: {
        type: Boolean,
        required: false,
      },
      ressourceHeader: {
        type: Object as PropType<MapRessource>,
        required: false,
      },
      fiche: {
        type: String,
        required: false,
      },
    },
    data () {
      return {
        toggleDialog: false,
        closeSection: false,
        localDialogWidth: undefined as number | string | undefined,
      };
    },
    computed: {
      dialog: {
        get (): boolean {
          if (this.dialogOpen != this.toggleDialog) {
            this.toggleDialog = this.dialogOpen;
          }
          return this.toggleDialog;
        },
        set (value: boolean) {
          this.toggleDialog = value;
        },
      },
      getWidth (): number | string {
        if (this.localDialogWidth != undefined) {
          return this.localDialogWidth;
        }
        if (this.dialogWidth) {
          return this.dialogWidth;
        }
        if (this.section && this.section.helper) {
          return 485;
        }
        if (this.helper) {
          return 600;
        } else if (this.fullscreen) {
          return 1500;
        } else if (this.midSize) {
          return 1200;
        } else {
          return 800
        }
      },
      currentProperties (): any {
        return {
          [this.section.type]: this.section.data,
          type: this.section.type,
          data: this.section.data,
          [this.section.propType]: this.section.propData,
          autoClear: this.section.autoClear,
          ressource: this.section.ressource,
          picto: this.section.picto,
          showButton: this.section.showButton,
          autoSave: this.section.autoSave,
          contextId: this.section.contextId,
          buttons: this.section.buttons,
          chat: this.section.chat,
          fullscreen: this.fullscreen,
          extended: true,
          closeSection: this.closeSection,
          dialog: true,
          moduleId: this.moduleId,
          isSalarie: this.isSalarie,
          readOnly: this.readOnly,
          showMissing: this.showMissing,
          ressourceHeader: this.ressourceHeader,
          fromSection: this.section.sectionName,
          section: this.section,
          owner: this.section.owner,
          adminInfo: this.section.adminInfo,
          fiche: this.fiche,
          requiredAttributs: this.section.requiredAttributs,
        };
      },
      events (): Record<string, () => void> {

        const event: any = {};
        event["closeDialog"] = () => this.closeDialog();
        event["setSize"] = (fullscreen: boolean, midSize: boolean, width?: number | string) => this.setSize(fullscreen, midSize, width);

        event["itemCreated"] = () => this.itemCreated();

        event["saved"] = (value: any) => this.setSaved(value);
        event["cancelled"] = () => this.setCancelled();

        event["updated"] = (value: any) => this.setUpdated(value);

        event["setMinimum"] = (value: any) => this.setMinimum(value);
        event["status"] = (status: FieldStatus) => this.statusChanged(status);
        return event;
      },
    },
    methods: {
      closeDialog () {
        if (this.$parent && this.$parent.route && this.$parent.route.section) {
          Route.closeSection(this.$parent.route.section);
        }
        if (this.section.autoSave) {
          this.closeSection = true;
        } else {
          this.$emit('closeDialog');
          this.dialog = false;
        }
      },
      setSize (fullscreen: boolean, midSize: boolean, width?: number | string) {
        this.localDialogWidth = width;
        this.$emit('setSize', fullscreen, midSize, width);
      },
      setUpdated (value: any): void {
        this.$emit('updated', value);
      },
      setMinimum (value: any): void {
        this.$emit('setMinimum', value);
      },
      setCancelled (): void {
        this.$emit('cancelled');
        this.$emit('closeDialog');
        this.dialog = false;
        this.closeSection = false;
      },
      itemCreated (): void {
        this.$emit('itemCreated');
      },
      setSaved (value: any): void {
        this.$emit('saved', value);
      },
      statusChanged (status: FieldStatus): void {
        this.$emit('status', status);
      },
    },
  });
</script>
